module.exports = __webpack_public_path__ + "static/media/sucursal.8cdd0ac8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sucursal.svg
// module id = 185
// module chunks = 0